import React from "react"
import DailyTimeslots from "./daily_timeslots"
import _ from "underscore"
import AddTimes from "./add"
import { Plus } from 'lucide-react'
import { Button } from '@/components/ui/button'

class WeeklyTimeslots extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      weekly_timeslots: this.initializeWeeklyTimeslots(props.times) || {},
      expanded: !props.times || props.times.length === 0
    }
  }

  initializeWeeklyTimeslots(weekly_timeslots) {
    const initial_weekly_timeslots = {
      monday: { name: 'Mon', timeslots: [] },
      tuesday: { name: 'Tue', timeslots: [] },
      wednesday: { name: 'Wed', timeslots: [] },
      thursday: { name: 'Thu', timeslots: [] },
      friday: { name: 'Fri', timeslots: [] },
      saturday: { name: 'Sat', timeslots: [] },
      sunday: { name: 'Sun', timeslots: [] },
    }

    for (const weekly_timeslot of weekly_timeslots) {
      const day_of_week = weekly_timeslot.day_of_week.toLowerCase()

      initial_weekly_timeslots[day_of_week].timeslots.push({
        start_time: weekly_timeslot.start_time,
        end_time: weekly_timeslot.end_time
      })
    }

    return initial_weekly_timeslots
  }

  formatTimes = (weekly_timeslots) => {
    const updated_times = []

    for (const day in weekly_timeslots) {
      const timeslots = weekly_timeslots[day].timeslots
      
      for (const timeslot of timeslots) {
        updated_times.push({
          day_of_week: day.charAt(0).toUpperCase() + day.slice(1),
          start_time: timeslot.start_time,
          end_time: timeslot.end_time
        })
      }
    }

    return updated_times
  }

  onCancelAddTime = () => {
    this.setState({expanded: false})
  }

  onToggleAddTime = () => {
    this.setState({expanded: !this.state.expanded})
  }

  onAddTimes = (daily_timeslots) => {
    const weekly_timeslots = this.state.weekly_timeslots
  
    for (const daily_timeslot of daily_timeslots) {
      const day = daily_timeslot.day_of_week.toLowerCase()
      weekly_timeslots[day].timeslots = weekly_timeslots[day].timeslots.concat(daily_timeslot.timeslots.times)
    }
  
    this.onSaveTimes(weekly_timeslots)
    this.onToggleAddTime()
  }

  onEditTimes = (daily_timeslots) => {
    const weekly_timeslots = this.state.weekly_timeslots
    const day = daily_timeslots.day_of_week.toLowerCase()
    weekly_timeslots[day].timeslots = daily_timeslots.timeslots.times

    this.onSaveTimes(weekly_timeslots)
  }

  onSaveTimes = (weekly_timeslots) => {
    this.setState({ weekly_timeslots: weekly_timeslots })
    const formatted_times = this.formatTimes(weekly_timeslots)
    this.props.onSaveTimes(formatted_times)
  }

  render(){
    const weekly_timeslots = this.state.weekly_timeslots

    const hasTimes = Object.values(weekly_timeslots).some(d => d.timeslots.length > 0)

    return (
      <React.Fragment>
        <div className="mb-4 flex items-center justify-between">
          <span className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">Weekly Schedule</span>
          {!this.state.expanded && (
            <Button variant="outline" size="sm" onClick={this.onToggleAddTime}>
              <Plus className="size-3.5"/> Add Times
            </Button>
          )}
        </div>
        {this.state.expanded &&
          <div className="mb-4">
            <AddTimes
              onCancel={this.onCancelAddTime}
              onAddTimes={this.onAddTimes}
            />
          </div>
        }
        {hasTimes &&
          <div className="divide-y">
            {_.map(weekly_timeslots, (daily_timeslots, day_of_week) => {
              return (
                <DailyTimeslots
                  key={`${day_of_week} - ${daily_timeslots}`}
                  day_of_week={day_of_week}
                  daily_timeslots={daily_timeslots}
                  onEditTimes={this.onEditTimes}
                />
              )
            })}
          </div>
        }
      </React.Fragment>
    )
  }
}

export default WeeklyTimeslots